import rosterClient from './clients/rosterClient';
import rrhhClient from './clients/rrhhClient';
import sgigoClient from './clients/sgigoClient';
import userManagerClient from './clients/userManagerClient';
import mailingClient from './clients/mailingClient';
import blobStorageClient from './clients/blobStorageClient';
import { systemId } from 'src/app.config';

const setAuthorizationToken = () => {
  var cookieValue = null;
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'Metbus.AuthToken') {
      cookieValue = value;
      break;
    }
  }

  const PERMISSIONS_TOKEN_KEY = `permission_token_${systemId}`;
  const permissionToken = sessionStorage.getItem(PERMISSIONS_TOKEN_KEY);

  if (permissionToken && cookieValue) {
    rosterClient.defaults.headers.common.Authorization = `Bearer ${permissionToken}`;
    rrhhClient.defaults.headers.common.Authorization = `Bearer ${cookieValue}`;
    sgigoClient.defaults.headers.common.Authorization = `Bearer ${cookieValue}`;
    userManagerClient.defaults.headers.common.Authorization = `Bearer ${cookieValue}`;
    mailingClient.defaults.headers.common.Authorization = `Bearer ${cookieValue}`;
    blobStorageClient.defaults.headers.common.Authorization = `Bearer ${cookieValue}`;
  } else {
    delete rosterClient.defaults.headers.common.Authorization;
    delete rrhhClient.defaults.headers.common.Authorization;
    delete sgigoClient.defaults.headers.common.Authorization;
    delete userManagerClient.defaults.headers.common.Authorization;
    delete mailingClient.defaults.headers.common.Authorization;
    delete blobStorageClient.defaults.headers.common.Authorization;
  }
};

export default setAuthorizationToken;
